import React, { useEffect, useState } from 'react';
import Listado from 'components/public/Listado/Listado';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useDispatch, useSelector } from 'react-redux';
import { titulosListadoVentas } from 'utils/constants';
import { fetchVentas } from 'utils/redux/features/ventasSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { VentaListado } from 'utils/models/types';
import { formatearFechaParaListado } from 'utils/utilities';
import { FechaString } from 'utils/models/interfaces';
import { ventasPorFecha } from 'services/servicioPost';
import { useError } from 'services/ErrorContext';

const Ventas = () => {
  const { ventas, loadingVentas, errorVentas } = useSelector((state: RootState) => state.ventas);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [ventasFiltradas, setVentasFiltradas] = useState<VentaListado[]>(ventas);
  const { setError, clearError, loading, setLoading } = useError();

  const dispatch = useDispatch<AppDispatch>();
  const error401 = errorVentas?.includes('permisos');

  useEffect(() => {
    setVentasFiltradas(ventas);
  }, [ventas]);

  useEffect(() => {
    dispatch(fetchVentas());
  }, [dispatch]);

  const ventasListado: VentaListado[] = ventasFiltradas
    ? ventasFiltradas.map((v: VentaListado) => {
        const sinFunciones: string = 'Sin funciones';
        const fechaInicioTemporada =
          v.FechaInicioTemporada !== '9999-12-31T23:59:59.9999999'
            ? formatearFechaParaListado(v.FechaInicioTemporada)
            : sinFunciones;
        const fechaFinTemporada =
          fechaInicioTemporada !== sinFunciones ? formatearFechaParaListado(v.FechaFinTemporada) : sinFunciones;

        return {
          ...v,
          CantEntradasVendidas: v.CantEntradasVendidas,
          FechaInicioTemporada: fechaInicioTemporada,
          FechaFinTemporada: fechaFinTemporada,
          MontoTotalVentaEntradas: `$${v.MontoTotalVentaEntradas}`,
          MontoTotalGananciaEntradas: `$${v.MontoTotalGananciaEntradas}`,
        };
      })
    : [];

  const convertDateRange = (dateRange: { startDate: string; endDate: string }) => {
    return {
      Id: 0,
      // Convertir a formato ISO
      FechaInicio: new Date(dateRange.startDate).toISOString(),
      FechaFin: new Date(dateRange.endDate).toISOString(),
    };
  };

  const filtrarPorFechas = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    clearError();

    const requestFiltroFechas: FechaString = convertDateRange({ startDate, endDate });

    try {
      const response = await ventasPorFecha(requestFiltroFechas, setError, setLoading);
      response && setVentasFiltradas(response);
    } catch (error) {
      console.error('Error de envío:', error);
      setError('Ocurrió un error al filtrar por fechas');
    }
  };

  const handleLimpiarFechas = () => {
    setStartDate('');
    setEndDate('');
    setVentasFiltradas(ventas);
  };

  return errorVentas ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={ventasListado}
      headCells={titulosListadoVentas}
      titulo="Ganancia por espectáculo"
      onFiltrar={filtrarPorFechas}
      startDate={startDate} // Pasar los valores al hijo si es necesario
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      onLimpiarFechas={handleLimpiarFechas}
      loading={loading || loadingVentas}
    />
  );
};

export default Ventas;
